export const paperProps = {
  overflow: "auto",
  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
  mt: "50px",
  height: "700px",
  ml: "-200px",
  width: "363px",
  "&:before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    right: 14,
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    transform: "translateY(-50%) rotate(45deg)",
    zIndex: 0,
  },
};
